import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const CustomSwiper = () => {
  const reviews = [
    {
      name: "Sophia Green",
      review:
        "I was skeptical at first, but after investing $10,000, I saw my earnings grow by $3,500 within just a month. Their team guided me through every step and made the process stress-free.",
      amount: "$10,000",
      image: "download (1).jpeg",
    },
    {
      name: "Ethan Johnson",
      review:
        "Their investment platform is incredibly user-friendly. I started with $2,000 and earned $800 within weeks. It's the best decision I've made this year!",
      amount: "$2,000",
      image: "download (4).jpeg",
    },
    {
      name: "Olivia Brown",
      review:
        "I appreciate how transparent and professional they are. I invested $5,000, and the returns have been consistent, earning me an additional $2,000 in two months.",
      amount: "$5,000",
      image: "download (2).jpeg",
    },
    {
      name: "Liam Williams",
      review:
        "My journey started with just $1,000. The returns have been phenomenal, adding $400 to my portfolio in just three weeks. Highly recommended!",
      amount: "$1,000",
      image: "download (3).jpeg",
    },
    {
      name: "Emma Davis",
      review:
        "With an initial investment of $15,000, I earned $5,000 in interest within two months. Their support team is available 24/7 to answer my questions. Fantastic experience!",
      amount: "$15,000",
      image: "download.jpeg",
    },
  ];

  return (
    <div className="bg-black text-white py-10">
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold">What Our Clients Say</h2>
      </div>
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        spaceBetween={30}
        slidesPerView={1}
        className="max-w-3xl mx-auto"
      >
        {reviews.map((review, index) => (
          <SwiperSlide key={index}>
            <div className="p-6 bg-gray-800 text-white rounded-lg text-center">
              {/* Profile Picture */}
              <div className="flex justify-center">
                <div className="w-24 h-24 rounded-full overflow-hidden mb-4 border-4 border-green-500">
                  <img
                    src={review.image}
                    alt={review.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              {/* Name */}
              <h3 className="text-xl font-bold mb-2">{review.name}</h3>
              {/* Review */}
              <p className="text-gray-300 mb-4">{review.review}</p>
              {/* Investment Amount */}
              <p className="text-green-400 text-lg font-semibold">
                Investment: {review.amount}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CustomSwiper;
